import {CSSProperties, FC} from 'react';


export interface IIconLinkedinProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLinkedin: FC<IIconLinkedinProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.626 0 12 0ZM8.513 18.14H5.59V9.349h2.923v8.793ZM7.052 8.148h-.02c-.98 0-1.614-.675-1.614-1.518 0-.863.653-1.52 1.653-1.52s1.615.657 1.634 1.52c0 .843-.634 1.518-1.653 1.518Zm11.999 9.994h-2.922v-4.704c0-1.182-.423-1.989-1.48-1.989-.808 0-1.289.544-1.5 1.07-.077.187-.096.45-.096.712v4.91H10.13s.039-7.967 0-8.792h2.923v1.245c.388-.6 1.083-1.451 2.633-1.451 1.923 0 3.365 1.256 3.365 3.957v5.042Z" clipRule="evenodd" />
        </svg>
    );
};
